<template>
  <div class="referred" style="width: 100%">
    <v-card-text>

      <div class="req-list">
        <div :class="'req-card '+card_style(item)" style="padding: 2px" v-longclick="() => long_click(item)"
             v-on:click="goToDetail(item)"

             v-for="item in request_items"
             :key="item.Id">
          <div>
            <div class="row ">
              <div class="col-6">
                <div
                  class="req-name"
                  v-text="item.ProductName"
                ></div>
              </div>
              <div class="col-3">
                <div
                  class="req-name"
                  v-text="item.Qty+' عدد '"
                ></div>

              </div>
              <div class="col-3">
                <div

                  class="req-name"
                  v-text="item.SourceBranchName"
                ></div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">{{ $t('no_records') }}</div>
      </infinite-loading>

      <v-dialog
        v-model="product_info_dialog"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{$t('information')}}</v-card-title>
          <v-card-text>
            <v-row>
              <v-row>
                <v-col style="font-weight: bold" class="p-1">
                  <p>{{selected_product_info.ProductName}}</p>
                  <p>{{selected_product_info.SourceBranchName}}</p>
                  <p>{{$t('technicianQ')}} {{selected_product_info.TechName}}</p>
                  <p>{{$t('summaryQ')}} {{selected_product_info.ProductDesc}}</p>
                  <p>{{selected_product_info.Qty}} {{$t('numbers')}}</p>
                  <p>{{selected_product_info.RequestCode}}</p>
                  <p>{{$t('referDescriptionQ')}} {{selected_product_info.Summary}}</p>
                  <p>قیمت خرید: {{selected_product_info.PurchaseAmount}}</p>
                  <p>قیمت فروش: {{selected_product_info.SaleAmount}}</p>

                  <v-row>
                    <v-col @click="open_image(img)" v-for="img in selected_product_info.Images" cols="6"><img
                      width="100%" height="auto" :src="img"></v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-row>
          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="product_info_dialog = false"
            >{{ $t('close') }}
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card-text>
    <v-row>
      <v-col>
        <v-btn v-on:click="dialog_model = true" class="width-100-p" color="primary" v-if="enable_finalize">{{ $t('add_status') }}</v-btn>
      </v-col>
    </v-row>
      <v-dialog
        v-model="dialog_model"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{ $t('add_status') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-select
                :items="status_list"
                :label="$t('NewStatusChangeStatus')"
                single-line
                item-text="label"
                item-value="value"
                v-model="selected_status_for_change"
              />
                <v-textarea
                  bordered
                  :label="$t('summary')"
                  v-model="status_summary"
                />
              <label>{{ $t('signature_place') }}</label>
              <VueSignaturePad ref="signaturePad" :options="signature_options" />

            </v-row>

          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="dialog_model = false"
            >
              {{$t('cancel')}}
            </v-btn>
            <v-btn
              v-if="selected_status_for_change != 0"
              class="accept-btn"
              text
              @click="go_to_finalize(0)"
            >
              {{$t('ok')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import {longClickDirective} from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  import VueSignaturePad from 'vue-signature-pad'
  Vue.use(VueSignaturePad)

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        signature_options: {
          dotSize: (0.5 + 2.5) / 2,
          minWidth: 0.5,
          maxWidth: 2.5,
          throttle: 16,
          minDistance: 5,
          backgroundColor: 'rgb(255,255,255)',
          penColor: 'black',
          velocityFilterWeight: 0.7,
          onBegin: () => {
          },
          onEnd: () => {
          }
        },
        dialog_model: false,
        status_summary: '',
        active_tab: 0,
        selected_status_for_change: 0,
        product_info_dialog: false,
        selected_product_info: {},
        list: [],
        status_list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        request_statuses: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {
      this.get_device_status();
    },

    methods: {
      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'blue'
        } else {
          return 'white'
        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },
      get_pre_requests($state) {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          RowCount: this.page,
          StatusId : self.request_statuses[12]
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProductRequestReferByUserId', send_data, {})
          .then(response => {
            self.request_items = []
            if (response.data.error == 0) {
              // console.log("my status", self.request_statuses[12])
              // response.data.Items = response.data.Items.filter(x => x.LastStatus == self.request_statuses[12]);

              response.data.Items.forEach(function (number) {
                self.request_items.push(JSON.parse(JSON.stringify(number)))
              })
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      open_image(img) {
        window.open(img, '_blank')
      },
      goToDetail(item) {
        if (this.disable_click) {
          return;
        }
        console.log("go to detail worked", item)
        // if (item.related_products != null) {
          this.selected_product_info = item;
          this.product_info_dialog = true;
        // }

      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")

        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;

        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";

        } else {
          return "";

        }
      },
      go_to_finalize(index_item) {
       var self = this;
        var array = this.request_items.filter(x => x.selected == true);
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
console.log(array)
        const send_data = {
          GRequestProductId: array[index_item].GoodsRequestProductId,
          StatusId: this.selected_status_for_change,
          Summary: this.status_summary,
          UserId: user_id,
        };

        this.axios.post('/AddGoodsRequestStatus', send_data, {})
          .then(response => {
if(array.length-1 == index_item){
  bus.$emit('show_toast', [2000, response.data.msg])
  self.dialog_model = false
  self.get_pre_requests()
  self.enable_finalize = false;

}else{
  self.go_to_finalize(index_item+1)
}
          }).catch(e => {
          this.errors.push(e)
        })

        },
      get_device_status() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt
            self.status_list = [{label: self.$t('select_status'), value: 0},
              {label: self.$t('returned'), value: self.request_statuses[9]},
              {label: self.$t('sent_to_technician'), value: self.request_statuses[10]},
              {label: self.$t('sent_to_warehouse'), value: self.request_statuses[13]},
              {label:"تحویل تعمیرگاه مربوطه شد", value: self.request_statuses[14]}
            ]

            self.get_pre_requests();

          }).catch(e => {
          this.errors.push(e)
        })
      },
      undo () {
        this.$refs.signaturePad.clearSignature()
      },
      save () {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/png')
        // var data_image = this.$refs.signaturePad.getPropImagesAndCacheImages()
        // console.log(this.$refs.signaturePad.getPropImagesAndCacheImages());
        // console.log(data);
        // Usage example:
        var file = this.dataURLtoFile(data, 'signature.png')
        console.log(file)
        // this.$refs.signaturePad.fromData(data)
        this.upload_image(file)
      },
      upload_image (image_data) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        var form_data = new FormData()
        form_data.append('UserId', user_id)
        form_data.append('ProcessId', this.$route.rec_id)
        form_data.append('Format', 'png')
        form_data.append('ReqType', this.req_type)
        form_data.append('Picture', image_data)

        //
        // const send_data = {
        //   "UserId": user_id,
        // };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('UploadFile', form_data, {})
          .then(response => {
            self.send_signature(response.data.ArchiveId, response.data.ImageName)
          }).catch(e => {
          this.errors.push(e)
        })
      },
      dataURLtoFile (dataurl, filename) {
        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type:mime })
      },

      send_signature (archive_id, file_name) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()

        var sign_type = 0

        if (this.req_type == 4) {
          sign_type = 1
        }
        if (this.req_type == 5) {
          sign_type = 2
        }

        const send_data = {
          UserId: user_id,
          ProcessId: this.$route.params.rec_id,
          ImageName: file_name,
          ArchiveId: archive_id,
          SigType: sign_type,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/SetRequestSignature', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // self.$router.push({name: 'attachment', params: {'rec_id': self.$route.params.rec_id}})
              if (self.req_type == 4 || self.req_type == 5) {
                self.$router.push({ name: 'requestAddress', params: { rec_id: self.$route.params.rec_id } })
              }
            } else {
              bus.$emit('show_toast', [1500, self.$t('errorUploadSign')])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
